module.exports = __webpack_public_path__ + "img/huan.57f938fd.png";